module.exports = __webpack_public_path__ + "static/img/045.b05932ba.png";